export const DownloadCsvActionTypes = {

    GET_TRANSACTION_CSV_FIRST: '@@downloadCSV/GET_TRANSACTION_CSV_FIRST',
    GET_TRANSACTION_CSV_LOADING: '@@downloadCSV/GET_TRANSACTION_CSV_LOADING',
    GET_TRANSACTION_CSV_SUCCESS: '@@downloadCSV/GET_TRANSACTION_CSV_SUCCESS',
    GET_TRANSACTION_CSV_ERROR: '@@downloadCSV/GET_TRANSACTION_CSV_ERROR',

    GET_ACCOUNT_CSV_FIRST: '@@downloadCSV/GET_ACCOUNT_CSV_FIRST',
    GET_ACCOUNT_CSV_LOADING: '@@downloadCSV/GET_ACCOUNT_CSV_LOADING',
    GET_ACCOUNT_CSV_SUCCESS: '@@downloadCSV/GET_ACCOUNT_CSV_SUCCESS',
    GET_ACCOUNT_CSV_ERROR: '@@downloadCSV/GET_ACCOUNT_CSV_ERROR',

    GET_TRADER_CSV_FIRST: '@@downloadCSV/GET_TRADER_CSV_FIRST',
    GET_TRADER_CSV_LOADING: '@@downloadCSV/GET_TRADER_CSV_LOADING',
    GET_TRADER_CSV_SUCCESS: '@@downloadCSV/GET_TRADER_CSV_SUCCESS',
    GET_TRADER_CSV_ERROR: '@@downloadCSV/GET_TRADER_CSV_ERROR',

    GET_USER_CSV_FIRST: '@@downloadCSV/GET_USER_CSV_FIRST',
    GET_USER_CSV_LOADING: '@@downloadCSV/GET_USER_CSV_LOADING',
    GET_USER_CSV_SUCCESS: '@@downloadCSV/GET_USER_CSV_SUCCESS',
    GET_USER_CSV_ERROR: '@@downloadCSV/GET_USER_CSV_ERROR',

    GET_COMMODITY_CSV_FIRST: '@@downloadCSV/GET_COMMODITY_CSV_FIRST',
    GET_COMMODITY_CSV_LOADING: '@@downloadCSV/GET_COMMODITY_CSV_LOADING',
    GET_COMMODITY_CSV_SUCCESS: '@@downloadCSV/GET_COMMODITY_CSV_SUCCESS',
    GET_COMMODITY_CSV_ERROR: '@@downloadCSV/GET_COMMODITY_CSV_ERROR',

    GET_DOWNLOAD_CSV_RESET: '@@downloadCSV/GET_DOWNLOAD_CSV_RESET',

}